<template>
  <section class="section container">
    <h1 class="title is-4 is-pulled-right mb-0">
      {{ $t("air project module configuration") }}
    </h1>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive">{{ $t("integrate") }}</label>
        </div>
        <div class="field">
          <generic-dropdown
            :title="$t('drive')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="field mt-5">
      <div class="title is-6">{{ $t("report text") }}</div>
      <div class="control">
        <textarea class="textarea" v-model="meta.report_text"></textarea>
      </div>
    </div>

    <div class="field mt-5">
      <div class="control">
        <button class="button is-rounded is-primary" @click="save">
          <span class="icon"><i class="fa fa-save"></i></span>
          <span>{{ $t("save") }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  success_message,
} from "@/utils";
import { isEmpty } from "lodash";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import "bulma-extensions/bulma-divider/dist/css/bulma-divider.min.css";

export default {
  name: "AirProjectSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {
        integrate_drive: false,
        drive_id: "",
      },
    };
  },
  methods: {
    save() {
      let v = this;
      v.$root.loader(true);
      save_configuration(this, v.meta)
        .then(() => {
          success_message(v.$t("configuration saved"));
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          v.$root.loader(false);
        });
    },
    drive_changed(drive) {
      let v = this;
      v.meta.drive_id = drive.drive_id;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        // console.log("conf", conf);
        if (!isEmpty(conf)) {
          if (conf.integrate_drive)
            v.meta.integrate_drive = conf.integrate_drive;
          // v.$refs.profile_dropdown.set_value(conf.visanet_payment_profile);
          if (conf.drive_id) v.meta.drive_id = conf.drive_id;
          v.$refs.drive_dropdown.set_value(conf.drive_id);
          if (conf.report_text) v.meta.report_text = conf.report_text;

          //   v.meta = conf;
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        v.$root.loader(false);
      });
  },
};
</script>

<style></style>
